// Types
import type { IChartProps } from "./types";

export function Chart({infocusID}: IChartProps) {

    return (<div data-infocusID={infocusID === 8}
        className="md:absolute
            print:!relative
            print:!left-0
            border-[1px] border-r-[#000]
            last-of-type:border-none
            opacity-100 -left-[100%]
            data-[inFocusID=true]:opacity-0
            data-[inFocusID=true]:left-0
            transition-all duration-[0.38s]
            w-full h-screen flex flex-col justify-between gap-4 p-8 bg-white
            page-break
        "
    >
            <div className="w-full flex flex-col justify-between gap-16">
                <span className="w-full h-auto flex flex-col  gap-4">
                    <span className="text-5xl">Valores dos imóveis x Área construída x Área do terreno</span>
                </span>

            </div>

            <div className="flex-1 w-[70%] overflow-auto flex flex-row items-center justify-center">
                <canvas id="property-amount-area"></canvas>
            </div>
        </div>
    )
}
